export enum MerchantActionType {
    GET_LIVE_MERCHANT = 'GET_LIVE_MERCHANT',
    GET_LIVE_MERCHANT_SUCCESS = 'GET_LIVE_MERCHANT_SUCCESS',
    GET_LIVE_MERCHANT_FAILURE = 'GET_LIVE_MERCHANT_FAILURE',

    CREATING_MERCHANT_LIVE_ACCOUNT = 'CREATING_MERCHANT_LIVE_ACCOUNT',
    CREATING_MERCHANT_LIVE_ACCOUNT_SUCCESS = 'CREATING_MERCHANT_LIVE_ACCOUNT_SUCCESS',
    CREATING_MERCHANT_LIVE_ACCOUNT_FAILURE = 'CREATING_MERCHANT_LIVE_ACCOUNT_FAILURE',

    GET_LIVE_MERCHANT_CATEGORIES = 'GET_LIVE_MERCHANT_CATEGORIES ',

    // TODO: Refactor old Action Types ->
    GET_ALL_BUSINESS_TYPES = 'GET_ALL_BUSINESS_TYPES',
    SET_ALL_BUSINESS_TYPES = 'SET_ALL_BUSINESS_TYPES',

    GET_MERCHANTS_CATEGORY = 'GET_MERCHANT_CATEGORY',
    SET_MERCHANTS_CATEGORY = 'SET_MERCHANT_CATEGORY',

    UPDATE_MERCHANT_DETAILS = 'UPDATE_MERCHANT_DETAILS',
    GET_MERCHANT_DETAILS = 'GET_MERCHANT_DETAILS',
    SET_MERCHANT_DETAILS = 'SET_MERCHANT_DETAILS',

    GET_MERCHANT_PROFILE = 'GET_MERCHANT_PROFILE',
    SET_MERCHANT_PROFILE = 'SET_MERCHANT_PROFILE',
    GET_KYC_STATUS = 'GET_KYC_STATUS',
    SET_KYC_STATUS = 'SET_KYC_STATUS',
    GET_KYC_TYPES = 'GET_KYC_TYPES',
    SET_KYC_TYPES = 'SET_KYC_TYPES',

    UPLOAD_MERCHANTS_ONBOARDING = 'UPLOAD_MERCHANTS_ONBOARDING',
    UPLOAD_KYC = 'UPLOAD_KYC',

    GET_ONBOARDING_PROFILE = 'GET_ONBOARDING_PROFILE',
    SET_ONBOARDING_PROFILE = 'SET_ONBOARDING_PROFILE',

    SET_ADD_NEW_BUSINESS = 'SET_ADD_NEW_BUSINESS',
    SET_ADD_NEW_BUSINESS_ERROR = 'SET_ADD_NEW_BUSINESS_ERROR',

    TOGGLE_USER_MODE = 'TOGGLE_USER_MODE',

    TOGGLING_APP_MODE = 'TOOGLE_APP_MODE',
    TOGGLING_APP_MODE_SUCCESS = 'TOGGLE_APP_MODE_SUCCESS',
    TOGGLING_APP_MODE_FAILURE = 'TOOGLE_APP_MODE_FAILURE',

    GET_MODE_TYPE = 'GET_MODE_TYPE',
    GET_MODE_TYPE_SUCCESS = 'GET_MODE_TYPE_SUCCESS',
    GET_MODE_TYPE_FAILURE = 'GET_MODE_TYPE_FAILURE',

    UPLOAD_MERCHANT_LOGO = 'UPLOAD_MERCHANT_LOGO',

    INVITE_EMPLOYEE = 'INVITE_EMPLOYEE',
    INVITE_EMPLOYEE_SUCCESS = 'INVITE_EMPLOYEE_SUCCESS',
    INVITE_EMPLOYEE_FAILURE = 'INVITE_EMPLOYEE_FAILURE',

    SUSPEND_USER = 'SUSPEND_USER',
    SUSPEND_USER_SUCCESS = 'SUSPEND_USER_SUCCESS',
    SUSPEND_USER_FAILURE = 'SUSPEND_USER_FAILURE',

    REVOKE_INVITE = 'REVOKE_INVITE',
    REVOKE_INVITE_SUCCESS = 'REVOKE_INVITE_SUCCESS',
    REVOKE_INVITE_FAILURE = 'REVOKE_INVITE_FAILURE',

    GET_INVITATION = 'GET_INVITATION',
    GET_INVITATION_SUCCESS = 'GET_INVITATION_SUCCESS',
    GET_INVITATION_FAILURE = 'GET_INVITATION_FAILURE',

    ACCEPT_INVITE = 'ACCEPT_INVITE',
    ACCEPT_INVITE_SUCCESS = 'ACCEPT_INVITE_SUCCESS',
    ACCEPT_INVITE_FAILURE = 'ACCEPT_INVITE_FAILURE',

    RESEND_INVITE = 'RESEND_INVITE',
    RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS',
    RESEND_INVITE_FAILURE = 'RESEND_INVITE_FAILURE',

    UPDATE_USER_ROLE = 'UPDATE_USER_ROLE',
    UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS',
    UPDATE_USER_ROLE_FAILURE = 'UPDATE_USER_ROLE_FAILURE',

    TWO_FA_SETUP = 'TWO_FA_SETUP',
    TWO_FA_SETUP_SUCCESS = 'TWO_FA_SETUP_SUCCESS',
    TWO_FA_SETUP_FAILURE = 'TWO_FA_SETUP_FAILURE',

    TWO_FA_ENABLE = 'TWO_FA_ENABLE',
    TWO_FA_ENABLE_SUCCESS = 'TWO_FA_ENABLE_SUCCESS',
    TWO_FA_ENABLE_FAILURE = 'TWO_FA_ENABLE_FAILURE',

    TWO_FA_STATUS = 'TWO_FA_STATUS',
    TWO_FA_STATUS_SUCCESS = 'TWO_FA_STATUS_SUCCESS',
    TWO_FA_STATUS_FAILURE = 'TWO_FA_STATUS_FAILURE',

    TWO_FA_DISABLE = 'TWO_FA_DISABLE',
    TWO_FA_DISABLE_SUCCESS = 'TWO_FA_DISABLE_SUCCESS',
    TWO_FA_DISABLE_FAILURE = 'TWO_FA_DISABLE_FAILURE'
}
